const pages: Record<string, string> = {
  'meta.home': 'A bilingual nonprofit advancing equity, opportunity and belonging for women, newcomers, families, persons with disabilities and underserved communities.',
  'meta.about': 'Learn about our mission, vision, values and commitment to bilingual, accessible and community-led change.',
  'meta.work': 'Explore our priority areas in women’s equality, newcomer inclusion, youth and family well-being, accessibility and systems change.',
  'meta.ark': 'A systemic-change initiative addressing credential-recognition, employment and leadership barriers facing newcomer and racialized professional women.',
  'meta.impact': 'Why systems change matters, our six-step approach and the indicators we use to measure progress.',
  'meta.partners': 'Cross-sector partnership and eight ways to partner with African and Canadian Community Ark of Hope.',
  'meta.involved': 'Volunteer, share your experience, build partnerships and help create more equitable community and professional pathways.',
  'meta.donate': 'Turn hope into opportunity: one-time gifts, monthly giving, activity sponsorship and in-kind contributions.',
  'meta.news': 'Organizational updates, community opportunities, learning resources and bilingual publications.',
  'meta.contact': 'Contact us, route your inquiry to the right team and read frequently asked questions.',
  'meta.privacy': 'How personal information is collected, used, protected and retained.',
  'meta.access': 'Our accessibility commitment and how to request information in an alternate format.',

  'seo.home': 'African and Canadian Community Ark of Hope',
  'seo.about': 'About African and Canadian Community Ark of Hope',
  'seo.work': 'Our Work: Community Equity and Inclusion Programs',
  'seo.ark': 'The Credentials ARK',
  'seo.involved': 'Get Involved: Volunteer and Partner With Us',
  'seo.impact': 'Impact and Systems Change',
  'seo.partners': 'Partners: Cross-Sector Collaboration',
  'seo.donate': 'Donate: Turn Hope Into Opportunity',
  'seo.news': 'News and Resources',
  'seo.contact': 'Contact Us',
  'seo.privacy': 'Privacy Summary',
  'seo.access': 'Accessibility Statement',

  'pg.back': 'Back to home',
  'pg.pending': 'This section is being prepared.',
  'pg.learn': 'Learn more',
  'pg.email': 'Email us',

  /* ---------------- ABOUT ---------------- */
  'ab.stamp': 'About Us',
  'ab.h1': 'Who We Are',
  'ab.sub': 'African and Canadian Community Ark of Hope is a bilingual nonprofit organization committed to advancing gender equality, inclusion and sustainable community well-being.',
  'ab.alt': 'Members of a bilingual community organization meeting in a bright hall',
  'ab.who.eyebrow': 'Who We Are',
  'ab.who.h': 'Respect for human dignity, and the belief that lasting change is shared.',
  'ab.who.p1': 'African and Canadian Community Ark of Hope is a bilingual nonprofit organization committed to advancing gender equality, inclusion and sustainable community well-being.',
  'ab.who.p2': 'We serve people whose talents and potential are too often limited by systemic discrimination, economic inequality, language barriers, inaccessible services and exclusion from decision-making spaces.',
  'ab.who.p3': 'Our work is rooted in respect for human dignity and in the belief that lasting change happens when communities are heard, institutions are accountable and opportunities are shared equitably.',
  'ab.who.p4': 'We connect community knowledge with professional expertise and cross-sector partnerships to build solutions that are practical, measurable and sustainable.',
  'ab.mission.h': 'Mission',
  'ab.mission.p': 'To advance gender equality and improve the social and economic well-being of women, girls, newcomers, families, persons with disabilities and other equity-deserving populations through bilingual, accessible and culturally responsive programs, advocacy, education, leadership development and strategic partnerships.',
  'ab.vision.h': 'Vision',
  'ab.vision.p': 'An inclusive and equitable society where every person, regardless of gender, race, language, disability, income, culture or immigration status, has the opportunity, resources, support and decision-making power needed to live with dignity and reach their full potential.',
  'ab.mandate.eyebrow': 'Mandate',
  'ab.mandate.h': 'What we are mandated to do.',
  'ab.m1t': 'Advance gender equality',
  'ab.m1p': 'Advance gender equality, women’s leadership, safety and economic security.',
  'ab.m2t': 'Remove systemic barriers',
  'ab.m2p': 'Identify and remove systemic barriers affecting newcomer, Black, racialized, Francophone, low-income and disability communities.',
  'ab.m3t': 'Fair access to employment',
  'ab.m3p': 'Promote fair access to employment, credential recognition, advancement and leadership opportunities.',
  'ab.m4t': 'Bilingual, accessible engagement',
  'ab.m4p': 'Deliver bilingual, accessible, culturally responsive and trauma-informed community engagement.',
  'ab.m5t': 'Strengthen youth and families',
  'ab.m5p': 'Strengthen youth, families and communities through education, mentorship, advocacy and connections to resources.',
  'ab.m6t': 'Partnerships for change',
  'ab.m6p': 'Build partnerships that produce sustainable, community-led institutional change.',
  'ab.values.eyebrow': 'Core Values',
  'ab.values.h': 'Seven values that shape our decisions.',
  'ab.v1t': 'Dignity',
  'ab.v1p': 'Every person deserves to be seen, heard and treated with respect.',
  'ab.v2t': 'Equity',
  'ab.v2p': 'Fairness requires identifying and removing barriers, not treating unequal circumstances as though they were the same.',
  'ab.v3t': 'Community leadership',
  'ab.v3p': 'People affected by an issue must have meaningful influence over the solutions.',
  'ab.v4t': 'Inclusion',
  'ab.v4p': 'Language, disability, race, gender, age, culture, income and immigration status must never become doors that remain closed.',
  'ab.v5t': 'Accountability',
  'ab.v5p': 'We value responsible governance, ethical stewardship, measurable outcomes and honest learning.',
  'ab.v6t': 'Collaboration',
  'ab.v6p': 'Systemic challenges require coordinated action across communities, institutions and sectors.',
  'ab.v7t': 'Hope in action',
  'ab.v7p': 'Hope is more than an aspiration; it is the disciplined work of building pathways forward.',
  'ab.bi.eyebrow': 'Bilingual Commitment',
  'ab.bi.h': 'Our Bilingual Commitment',
  'ab.bi.p': 'We are committed to meaningful service and engagement in English and French. Our bilingual approach goes beyond translation. We seek the participation of Francophone community members and organizations in project design, advisory roles, delivery, evaluation and decision-making.',
  'ab.lead.eyebrow': 'Leadership',
  'ab.lead.h': 'Leadership',
  'ab.lead.p': '[Board and team profiles: to be added]',

  /* ---------------- WORK ---------------- */
  'wk.stamp': 'Our Work',
  'wk.h1': 'Our Work',
  'wk.sub': 'Our work addresses immediate community realities while also confronting the policies, practices, attitudes, networks and power imbalances that produce unequal outcomes. The following areas guide our program development and partnerships.',
  'wk.alt': 'A mother and daughter reading together beside a window at golden hour',
  'wk.areas.eyebrow': 'Areas of Focus',
  'wk.areas.h': 'Six areas that guide our programs and partnerships.',
  'wk.pending': '[Program description: to be added]',
  'wk.a1t': 'Women’s Equality and Leadership',
  'wk.a2t': 'Newcomer and Racialized Professional Inclusion',
  'wk.a3t': 'Youth and Family Empowerment',
  'wk.a4t': 'Accessibility and Disability Inclusion',
  'wk.a5t': 'Community Well-Being',
  'wk.a6t': 'Education Advocacy and Systems Change',
  'wk.a1p': 'We support initiatives that strengthen women’s economic security, leadership, representation and influence. Our approach centres women’s lived experience and works with institutions to improve the conditions that shape access to opportunity.',
  'wk.a2p': 'We work to address barriers such as non-recognition of international credentials, demands for Canadian experience, racial and gender bias, limited professional networks and unequal access to advancement. We engage women, employers, professional bodies, educational institutions and settlement organizations in developing fairer pathways.',
  'wk.a3p': 'We promote resilience, life skills, educational participation, mentorship, healthy relationships and stronger connections to community resources. Our aim is to help young people and families build stability, confidence and meaningful belonging.',
  'wk.a4p': 'We advocate for environments, communications and opportunities that are accessible by design. We encourage the meaningful participation of persons with disabilities in planning, leadership and evaluation.',
  'wk.a5p': 'We support culturally responsive approaches to mental wellness, social connection, prevention, early support and community navigation. We recognize that well-being is shaped by income, housing, employment, safety, discrimination and belonging.',
  'wk.a6p': 'We convene community members and decision-makers, develop practical resources, share evidence, strengthen institutional capacity and support policy and practice improvements that can continue beyond a single project.',
  'wk.cta.h': 'Explore the wider work.',
  'wk.cta.p': 'See the initiative that brings these areas together, and how we measure change.',

  /* ---------------- CREDENTIALS ARK ---------------- */
  'ar.stamp': 'The Credentials ARK',
  'ar.h1': 'The Credentials ARK',
  'ar.sub': 'Removing Systemic Barriers for Newcomer and Racialized Professional Women',
  'ar.badge': 'Signature systemic-change initiative under development',
  'ar.alt': 'An internationally trained professional holding a credential folder in a quiet office at dusk',
  'ar.ch.eyebrow': 'The Challenge',
  'ar.ch.h': 'The Challenge',
  'ar.ch.p': 'Many newcomer and racialized professional women arrive in Canada with degrees, professional qualifications, multilingual abilities and years of experience. Yet their talents may be overlooked because of complex credential-recognition processes, Canadian-experience requirements, limited professional networks, discriminatory recruitment practices and unequal access to mentorship, sponsorship and leadership pathways.',
  'ar.res.eyebrow': 'Our Response',
  'ar.res.h': 'Our Response',
  'ar.res.p': 'The Credentials ARK is designed to bring professional women and the institutions that influence their opportunities into a shared process of research, co-design, testing and institutional action. The initiative will focus on changing systems rather than asking women to carry the full burden of overcoming discriminatory barriers.',
  'ar.act.eyebrow': 'Proposed Activities',
  'ar.act.h': 'Proposed Activities',
  'ar.a1': 'Bilingual consultations, surveys and focus groups led by the experiences of newcomer and racialized professional women.',
  'ar.a2': 'A Women’s Advisory Circle with meaningful influence over project decisions.',
  'ar.a3': 'Cross-sector collaboration with employers, colleges, professional associations, regulators, settlement agencies and community organizations.',
  'ar.a4': 'Co-development and testing of the bilingual Credentials ARK Toolkit.',
  'ar.a5': 'Institutional training on GBA Plus, bias, fair credential assessment, inclusive recruitment and equitable advancement.',
  'ar.a6': 'Support for participating organizations to assess and improve policies and practices.',
  'ar.a7': 'External evaluation, shared learning and knowledge mobilization.',
  'ar.out.eyebrow': 'Intended Results',
  'ar.out.h': 'Intended Results',
  'ar.out.p': 'The initiative aims to strengthen institutional accountability, improve credential-recognition and employment practices, increase cross-sector coordination, and create more equitable pathways to meaningful employment, advancement and leadership for newcomer and racialized professional women.',
  'ar.cta1': 'Share Your Experience',
  'ar.cta2': 'Partner With Us',
  'ar.alt2': 'A bilingual advisory circle in discussion around a table',
  'ar.note': 'The Credentials ARK is under development. Proposed activities are not yet funded or operating.',

  /* ---------------- IMPACT ---------------- */
  'im.stamp': 'Impact and Systems Change',
  'im.h1': 'Impact and Systems Change',
  'im.sub': 'Individual determination is powerful, but determination alone cannot remove institutional barriers.',
  'im.alt': 'A co-design workshop with notes arranged on a wall',
  'im.why.eyebrow': 'Why Systems Change',
  'im.why.h': 'Why Systems Change',
  'im.why.p': 'Individual determination is powerful, but determination alone cannot remove institutional barriers. Sustainable progress requires changes in the rules, relationships, resources, attitudes and decision-making structures that shape people’s opportunities.',
  'im.step.eyebrow': 'Our Approach',
  'im.step.h': 'Our Approach',
  'im.s1t': 'Listen',
  'im.s1p': 'Gather evidence and learn directly from people affected by the issue.',
  'im.s2t': 'Connect',
  'im.s2p': 'Bring communities, institutions and decision-makers into purposeful collaboration.',
  'im.s3t': 'Co-design',
  'im.s3p': 'Develop solutions with, not merely for, the people who will be affected.',
  'im.s4t': 'Test',
  'im.s4p': 'Pilot practical tools, policies and approaches in real organizational settings.',
  'im.s5t': 'Change',
  'im.s5p': 'Support institutions to adopt and implement stronger policies and practices.',
  'im.s6t': 'Measure and sustain',
  'im.s6p': 'Use external evaluation, transparent learning and long-term commitments to preserve results.',
  'im.measure.eyebrow': 'Evaluation',
  'im.measure.h': 'How We Measure Progress',
  'im.m1': 'Participation and representation of the communities most affected.',
  'im.m2': 'Partner commitments and strength of cross-sector collaboration.',
  'im.m3': 'Changes in institutional knowledge, attitudes and decision-making capacity.',
  'im.m4': 'Policies, procedures and practices adopted or improved.',
  'im.m5': 'Implementation of organizational action plans.',
  'im.m6': 'Participant and partner feedback, including unintended impacts and lessons learned.',
  'im.m7': 'Evidence that solutions continue beyond the original funding period.',

  /* ---------------- PARTNERS ---------------- */
  'pt.stamp': 'Partners',
  'pt.h1': 'Partners',
  'pt.sub': 'Partnership is how systems move.',
  'pt.alt': 'Partners from different sectors in a working session',
  'pt.phil.eyebrow': 'Partnership Is How Systems Move',
  'pt.phil.h': 'Partnership Is How Systems Move',
  'pt.phil.p1': 'No single organization can dismantle systemic barriers alone.',
  'pt.phil.p2': 'We welcome collaboration with nonprofits, employers, educational institutions, professional associations, credential-recognition bodies, settlement agencies, Francophone organizations, disability organizations, governments, funders and community leaders.',
  'pt.ways.eyebrow': 'Ways to Partner',
  'pt.ways.h': 'Ways to Partner',
  'pt.w1': 'Refer and engage community participants.',
  'pt.w2': 'Join advisory and cross-sector working groups.',
  'pt.w3': 'Host consultations, learning sessions or pilot activities.',
  'pt.w4': 'Review and improve institutional policies and practices.',
  'pt.w5': 'Provide mentorship, sponsorship or professional-network access.',
  'pt.w6': 'Contribute expertise, venues, technology or other in-kind resources.',
  'pt.w7': 'Support research, evaluation and knowledge sharing.',
  'pt.w8': 'Invest in sustainable community-led solutions.',
  'pt.logos': '[Partner logos: to be added]',
  'pt.cta': 'Partner With Us',
  'pt.form.eyebrow': 'Partnership Inquiry',
  'pt.form.h': 'Partner With Us',
  'pt.form.p': 'Tell us about your organization and the contribution you would like to explore.',

  /* ---------------- GET INVOLVED ---------------- */
  'iv.stamp': 'Get Involved',
  'iv.h1': 'Get Involved',
  'iv.sub': 'Volunteers help extend the reach of our work and strengthen the communities we serve.',
  'iv.alt': 'A lit community hall beside still water at blue hour',
  'iv.vol.eyebrow': 'Volunteer',
  'iv.vol.h': 'Volunteer',
  'iv.vol.p': 'Volunteers help extend the reach of our work and strengthen the communities we serve. Opportunities may include community outreach, event support, research, translation, mentorship, administration, digital communications and professional expertise.',
  'iv.exp.eyebrow': 'Share Your Experience',
  'iv.exp.h': 'Share Your Experience',
  'iv.exp.p': 'If you are a newcomer or racialized professional woman who has encountered barriers related to credentials, employment, promotion or leadership, your experience can help shape better solutions. Participation is voluntary, and privacy and informed consent will guide every engagement process.',
  'iv.amb.eyebrow': 'Community Ambassador',
  'iv.amb.h': 'Become a Community Ambassador',
  'iv.amb.p': 'Community ambassadors help share trusted information, connect people with opportunities, and ensure that project activities remain grounded in diverse community realities.',

  /* ---------------- DONATE ---------------- */
  'dn.stamp': 'Donate',
  'dn.h1': 'Donate',
  'dn.sub': 'Your support helps strengthen community engagement, accessibility, bilingual participation, research, mentorship, education and the development of practical solutions to systemic barriers.',
  'dn.alt': 'Warm light falling across a quiet community hall at dusk',
  'dn.why.eyebrow': 'Turn Hope Into Opportunity',
  'dn.why.h': 'Turn Hope Into Opportunity',
  'dn.why.p': 'Your support helps strengthen community engagement, accessibility, bilingual participation, research, mentorship, education and the development of practical solutions to systemic barriers. Every contribution helps create a fairer path for women, newcomers, families and underserved communities.',
  'dn.opt.eyebrow': 'Suggested Contribution Options',
  'dn.opt.h': 'Suggested contribution options',
  'dn.opt.p': 'Choose an option below to include it in your message. No payment is processed on this website.',
  'dn.o1': 'One-time gift',
  'dn.o2': 'Monthly gift',
  'dn.o3': 'Sponsor an activity',
  'dn.o4': 'Corporate or foundation support',
  'dn.o5': 'In-kind contribution',
  'dn.opt.selected': 'Selected',
  'dn.opt.select': 'Select this option',
  'dn.cta': 'Continue to the donation interest form',
  'dn.tax.eyebrow': 'Tax Receipts',
  'dn.tax.h': 'Tax receipts',
  'dn.tax.p': '[Tax-receipt information: to be confirmed].',
  'dn.tax.note': 'No tax receipt is promised until it is confirmed with you directly.',
  'dn.form.eyebrow': 'Donation Interest',
  'dn.form.h': 'Donation Interest',
  'dn.form.p': 'Let us know how you would like to give, and our team will follow up with you directly.',

  /* ---------------- NEWS ---------------- */
  'nw.stamp': 'News and Resources',
  'nw.h1': 'News and Resources',
  'nw.sub': 'This section will share organizational updates, community opportunities, learning resources, project findings, bilingual publications, partner announcements and stories of change.',
  'nw.alt': 'Hands arranging printed resources on a table',
  'nw.filter.1': 'Organizational news',
  'nw.filter.2': 'Community opportunities',
  'nw.filter.3': 'Research and reports',
  'nw.filter.4': 'Employment and credential resources',
  'nw.filter.5': 'Women’s leadership',
  'nw.filter.6': 'Bilingual resources',
  'nw.filter.7': 'Partner updates',
  'nw.empty': 'Updates coming soon.',
  'nw.note': 'Updates will be published in English and French as they become available.',

  /* ---------------- CONTACT ---------------- */
  'cn.stamp': 'Contact Us',
  'cn.h1': 'Contact Us',
  'cn.lead': 'Let Us Connect',
  'cn.sub': 'Whether you are seeking information, exploring a partnership, interested in volunteering, or looking for ways to support the mission, we welcome your message.',
  'cn.alt': 'Calm water at dusk under a deep teal sky',
  'cn.route.eyebrow': 'Inquiry Routing',
  'cn.route.h': 'Select a reason and the form will be set for you.',
  'cn.r1': 'General inquiries',
  'cn.r2': 'Partnerships',
  'cn.r3': 'Programs and participation',
  'cn.r4': 'Volunteering',
  'cn.r5': 'Media',
  'cn.r6': 'Donations',
  'cn.details.eyebrow': 'Contact',
  'cn.details.h': 'Contact',
  'cn.details.email': 'Email',
  'cn.details.phone': 'Phone',
  'cn.details.address': 'Mailing address',
  'cn.details.hours': 'Service hours',
  'cn.details.social': 'Social links',
  'cn.details.phoneV': '[Phone: to be added]',
  'cn.details.addressV': '[Mailing address: to be added]',
  'cn.details.hoursV': '[Service hours: to be added]',
  'cn.details.socialV': '[Social links: to be added]',
  'cn.form.eyebrow': 'Contact Form',
  'cn.form.h': 'Send us a message',

  /* ---------------- LEGAL ---------------- */
  'pp.stamp': 'Privacy',
  'pp.h1': 'Privacy',
  'pp.sub': 'Data collection privacy summary.',
  'pp.pending': 'We collect only the personal information needed to respond to inquiries, process registrations, manage volunteer or partnership requests, and carry out authorized organizational activities. We will explain why information is collected, seek consent where required, protect information from unauthorized access, and retain it only as long as necessary.',
  'pp.summary.h': 'Privacy Summary',
  'pp.alt': 'Still water and soft reeds at dusk',
  'ac.stamp': 'Accessibility',
  'ac.h1': 'Accessibility',
  'ac.sub': 'Our commitment to accessibility.',
  'ac.pending': 'African and Canadian Community Ark of Hope is committed to providing an accessible and inclusive website. We aim to make digital information usable by people with diverse disabilities, devices, communication needs and levels of digital literacy. If you encounter a barrier or require information in an alternate format, please contact us so that we can work with you to provide access.',
  'ac.statement.h': 'Accessibility Statement',
  'ac.note': 'If something on this website creates a barrier for you, please tell us.',
  'ac.alt': 'A gentle shoreline with calm water and soft light',

  /* ---------------- FORMS ---------------- */
  'f.areas': 'Areas of interest',
  'f.areasHint': 'Select as many as you like.',
  'f.vo1': 'Community outreach',
  'f.vo2': 'Event support',
  'f.vo3': 'Research',
  'f.vo4': 'Translation',
  'f.vo5': 'Mentorship',
  'f.vo6': 'Administration',
  'f.vo7': 'Digital communications',
  'f.vo8': 'Professional expertise',
  'f.barriers': 'Barriers encountered',
  'f.barriersPh': 'You may describe barriers related to credentials, employment, promotion or leadership.',
  'f.connections': 'Community connections',
  'f.connectionsPh': 'Describe the communities, networks or groups you are connected to.',
  'f.expertise': 'Area of expertise',
  'f.contribution': 'Proposed contribution',
  'f.contributionPh': 'Tell us what you would like to contribute or explore with us.',
  'f.reason': 'Reason for contact',
  'f.option': 'Option',
  'f.msgPh': 'Write your message here (500 characters maximum).',
  'f.hint': 'Please do not include sensitive personal information in this message.',

  /* ---------------- FAQ ANSWERS ---------------- */
  'faq.a1': 'We focus on women, girls, newcomers, families, persons with disabilities and other equity-deserving communities, with particular attention to people facing intersecting racial, gender, language, economic and immigration-related barriers.',
  'faq.a2': 'The organization is committed to bilingual engagement and to expanding accessible participation in both official languages. Availability may vary by activity, and each program page should clearly identify its language options.',
  'faq.a3': 'No. It is designed as a systemic-change initiative that works with women and institutions to improve the policies and practices shaping credential recognition, recruitment, retention, promotion and leadership.',
  'faq.a4': 'Use the partnership inquiry form to describe your organization, area of expertise and proposed contribution. The team will follow up to explore alignment and next steps.',
  'faq.a5': 'Yes. Volunteer opportunities will be posted as they become available. Applicants may identify their interests, languages, professional skills, availability and accommodation needs.',
  'faq.a6': 'Tax-receipt eligibility depends on the organization’s current legal and charitable status. The donation page will clearly state whether official receipts are available.',
};

export default pages;